/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router-dom";
import AppLayout from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import { useEffect, useState } from "react";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { BodyDiv } from "../../components/components-style";
import { Button } from "../../components/ui/button";
import { COLORS } from "../../assets/utils/enums/colors";
import companyIcon from "../../assets/images/icons/dark/company-icon.svg";
import {
  LittleHeadline,
  LittleSubHeadline,
  LittleText,
  NotificationText,
} from "../../components/typography";
import { ItemMainBlock } from "../project/details";
import {
  TypeClientEnum,
  typeClientObj,
} from "../../assets/utils/enums/project";
import styled from "styled-components";
import StatisticBlock, {
  DataStatisticProps,
} from "../../components/ui/statistics-block";
import projectWhiteIcon from "../../assets/images/icons/projects-white-icon.svg";
import pieIcon from "../../assets/images/icons/pie-one-icon.svg";
import basketIcon from "../../assets/images/icons/basket-icon.svg";
import DataTable from "../../components/ui/table";
import { tableColumnType, TableTypeEnum } from "../../assets/utils/enums/table";
import { ProjectRow } from "../../assets/utils/table-types";
import getData from "../../api/project-request";
import {
  API_URL_COMPANY,
  API_URL_CONTACT,
  API_URL_PROJECT,
} from "../../constants";
import CustomToast from "../../components/ui/custom-toast";
import toast from "react-hot-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import { useStatisticPeriod } from "../../assets/store/useStatisticPeriod";
import { currencies } from "../../assets/utils/data/items";
import { LinkText } from "../../components/ui/error-text";
import { deleteArrFunc } from "../../assets/utils/request-function";
import { ActionsEnum } from "../../assets/utils/enums/settings";
import { ModalWindowType } from "../../components/ui/modal-window";
import { findStructureFieldByKey, useStructureStore } from "../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../assets/utils/enums/basket";
import { useStructureColumnsStore } from "../../assets/store/useStructureColumnsStore";

export default function DetailsCompanyPage() {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { period } = useStatisticPeriod();
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [site, setSite] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [contactEmail, setContactEmail] = useState<string>();
  const [contactFullname, setContactFullname] = useState<string>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [type, setType] = useState<TypeClientEnum>(
    TypeClientEnum.POTENTIAL_CLIENT
  );
  const [projects, setProjects] = useState<ProjectRow[]>([]);
  const [projStatistic, setProjStatistic] = useState<DataStatisticProps[]>([]);
  const [finStatistic, setFinStatistic] = useState<DataStatisticProps[]>([]);
  const [saleStatistic, setSaleStatistic] = useState<DataStatisticProps[]>([]);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const [employees, setEmployees] = useState<
    {
      id: number;
      fullName: string;
      email: string;
      phoneNumber: string;
    }[]
  >([]);

  const projectFields = useStructureStore(
    (s) => s.structures[ObjectsEnum.PROJECTS].fields
  )
  const fields = useStructureStore(
    (s) => s.structures[ObjectsEnum.COMPANIES].fields
  )
  const baseProjectColumns =
    tableColumnType[TableTypeEnum.PROJECTS].columns;

  const tableProjectStructure = useStructureColumnsStore(
    baseProjectColumns,
    projectFields
  );

  const [modalWindowSettings, setModalWindowSettings] =
    useState<ModalWindowType>({
      isOpen: false,
      onConfirm: () => { },
      onCancel: () => { },
    });

  const getProjects = async () => {
    setIsLoading(true);
    try {
      const data = await getData(`${API_URL_COMPANY}/${id}/projects`);
      if (Array.isArray(data)) {
        setProjects(data);
      } else {
        setProjects([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setProjects([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const data = await getData(`${API_URL_COMPANY}/company-details/${id}`);
        if (!data) return;

        setName(data.name);
        setType(
          (data.customerType as TypeClientEnum) ||
          TypeClientEnum.POTENTIAL_CLIENT
        );
        setPhone(data.phoneNumber || "—");
        setSite(data.siteLink);
        setDescription(data.description || "Опис відсутній.");
        setContactEmail(data.contactEmail);
        setContactFullname(data.contactFullname || "Представника немає. ");
      } catch (e) {
        console.error("Error loading company:", e);
        toast((t) => (
          <CustomToast
            t={t}
            text={"Не вдалося завантажити дані компанії"}
            type={ToastTypeEnum.ERROR}
          />
        ));
      } finally {
        setIsLoading(false);
      }
    };

    const getContactsByCompany = async () => {
      setIsLoading(true);

      try {
        const data = await getData(
          `${API_URL_CONTACT}/get-company-contacts-by-id?id=${id}`
        );
        if (Array.isArray(data)) {
          setEmployees(data);
        } else {
          setEmployees([]);
        }
      } catch (error: any) {
        console.log(error.message);
        setEmployees([]);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 100);
      }
    };

    loadData();
    getProjects();
    getContactsByCompany();
  }, [id]);

  useEffect(() => {
    getProjects();
    setIsDeleted(false);
  }, [isDeleted]);

  useEffect(() => {
    const getStatisticProject = async () => {
      setIsLoading(true);
      const data = await getData(
        `${API_URL_COMPANY}/${id}/stats?period=${period}`
      );

      setProjStatistic([
        {
          title: "Всі проєкти",
          value: data.totalProjects,
          percent: "",
        },
        {
          title: "Активні проєкти",
          value: data.activeProjects,
          percent: `${data.activeGrowthPercent}`,
        },
      ]);
    };

    const getStatisticFinance = async () => {
      setIsLoading(true);
      const data = await getData(
        `${API_URL_COMPANY}/${id}/finance-summary?period=${period}&currency=${currencies[1].code}`
      );

      setFinStatistic([
        ...(findStructureFieldByKey(fields, "income")?.visible ? [{
          title: findStructureFieldByKey(fields, "income")?.label ?? "Надходження",
          value: data.formattedIncomes || "0",
          percent: data.incomesChangePercent,
        }] : []),
        ...(findStructureFieldByKey(fields, "expense")?.visible ? [{
          title: findStructureFieldByKey(fields, "expense")?.label ?? "Витрати",
          value: data.formattedExpenses || "0",
          percent: data.expensesChangePercent,
        }] : []),
      ]);
    };

    const getStatisticSales = async () => {
      setIsLoading(true);
      const data = await getData(
        `${API_URL_COMPANY}/${id}/sales-summary?period=${period}`
      );

      setSaleStatistic([
        {
          title: "Всі продажі",
          value: data.totalSales || "0",
          percent: "",
        },
        {
          title: "У процесі",
          value: data.inProgressSales || "0",
          percent: "",
        },
        {
          title: "Завершені",
          value: data.completedSales || "0",
          percent: "",
        },
      ]);
    };

    setTimeout(() => {
      getStatisticProject();
      getStatisticSales();
      getStatisticFinance();
      setIsLoading(false);
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period]);

  return (
    <AppLayout
      className="d-flex flex-column align-items-center gap-2"
      blockType="details-project"
      loaderState={isLoading}
      modalWindow={modalWindowSettings}
    >
      <Headline
        headline={HeadlineTypeEnum.COMPANIES}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Повернутися до Компаній"
        btn_link="/companies/main"
        isEdit={false}
      />
      <BodyDiv
        data-class="detail-main-block"
        className="justify-content-between flex-row w-100"
      >
        <div className="d-flex flex-column w-100 gap-3">
          <div className="d-flex align-items-center justify-content-between">
            <span className="d-flex align-items-center gap-3">
              <Button
                bgcolor={COLORS.main2}
                txtcolor={COLORS.white}
                brcolor={"transparent"}
                width="auto"
                className="center-btn"
                brradius="12px"
                type="large"
                onClick={() => { }}
              >
                <img
                  src={companyIcon}
                  className="object-fit-none"
                  alt="company-icon"
                />
              </Button>
              <LittleHeadline>{name}</LittleHeadline>
            </span>
            {findStructureFieldByKey(fields, "customerType")?.visible && <Button
              bgcolor={typeClientObj[type].bgColor}
              txtcolor={typeClientObj[type].txColor}
              brcolor={"transparent"}
              width="auto"
              className="center-btn"
              brradius="12px"
              type="small"
              onClick={() => { }}
            >
              <LittleText>{type}</LittleText>
            </Button>}
          </div>
          <span className="w-100 d-flex gap-4">
            {findStructureFieldByKey(fields, "description")?.visible && <ItemMainBlock>
              <NotificationText>{findStructureFieldByKey(fields, "description")?.label ?? "Опис"}</NotificationText>
              <LittleSubHeadline>{description}</LittleSubHeadline>
            </ItemMainBlock>}
            {findStructureFieldByKey(fields, "siteLink")?.visible && <ItemMainBlock>
              <NotificationText>{findStructureFieldByKey(fields, "siteLink")?.label ?? "Посилання на сайт компанії"}</NotificationText>
              {!site ? (
                <LittleText>—</LittleText>
              ) : (
                <a href={site} target="_blank" rel="noopener noreferrer">
                  <LittleSubHeadline>{site}</LittleSubHeadline>
                </a>
              )}
            </ItemMainBlock>}
          </span>
          {findStructureFieldByKey(fields, "contactEmail")?.visible && <span className="w-100 d-flex gap-3">
            <ItemMainBlock>
              <NotificationText>{findStructureFieldByKey(fields, "contactEmail")?.label ?? "Представник компанії"}</NotificationText>
              <LittleSubHeadline>{contactFullname}</LittleSubHeadline>
            </ItemMainBlock>
            <ItemMainBlock>
              <NotificationText>Номер телефону</NotificationText>
              <LittleSubHeadline>{phone}</LittleSubHeadline>
            </ItemMainBlock>
            <ItemMainBlock>
              <NotificationText>Електронна пошта</NotificationText>
              <span className="d-flex">
                {" "}
                {!contactEmail ? (
                  "—"
                ) : (
                  <LinkText mainText={contactEmail!} addText={contactEmail!} />
                )}
              </span>
            </ItemMainBlock>
          </span>}
        </div>

        <ButtonSpan>
          <Button
            bgcolor={COLORS.secondary1}
            txtcolor={COLORS["light-gray"]}
            brcolor={"transparent"}
            width="100%"
            className="center-btn"
            brradius="12px"
            type="small"
            onClick={() => {
              navigate(`/companies/update/${id}`);
            }}
          >
            <LittleText>Редагувати дані</LittleText>
          </Button>
          <Button
            bgcolor={COLORS.warning}
            txtcolor={COLORS["light-gray"]}
            brcolor={"transparent"}
            width="100%"
            className="center-btn"
            brradius="12px"
            type="small"
            onClick={() => {
              setModalWindowSettings({
                isOpen: true,
                onConfirm: () => {
                  if (!id) return;
                  deleteArrFunc(
                    [Number.parseInt(id)],
                    `${API_URL_COMPANY}/archive`,
                    setIsDeleted,
                    "companyIds"
                  );
                  setTimeout(() => {
                    setModalWindowSettings((prev) => ({
                      ...prev,
                      isOpen: false,
                    }));
                    navigate("/companies/main");
                  }, 100);
                },
                onCancel: () =>
                  setModalWindowSettings((prev) => ({
                    ...prev,
                    isOpen: false,
                  })),
                action: ActionsEnum.DELETE,
              });
            }}
          >
            <LittleText>Видалити компанію</LittleText>
          </Button>
        </ButtonSpan>
      </BodyDiv>
      {(findStructureFieldByKey(fields, "income")?.visible || findStructureFieldByKey(fields, "expense")?.visible || findStructureFieldByKey(fields, "project")?.visible || findStructureFieldByKey(fields, "selling")?.visible) && <div data-class="statistics-block" className="align-items-center flex-wrap w-100">
        {findStructureFieldByKey(fields, "project")?.visible && <StatisticBlock
          iconColor={COLORS.secondary1}
          iconUrl={projectWhiteIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={projStatistic}
        />}
        {findStructureFieldByKey(fields, "selling")?.visible && <StatisticBlock
          iconColor={COLORS["bg-text-color"]}
          iconUrl={basketIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={saleStatistic}
        />}
        {(findStructureFieldByKey(fields, "income")?.visible || findStructureFieldByKey(fields, "expense")?.visible) && <StatisticBlock
          iconColor={COLORS.blue}
          iconUrl={pieIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={finStatistic}
        />}
      </div>}
      <DataTable
        table={{ ...tableColumnType[TableTypeEnum.PROJECTS], columns: tableProjectStructure, name: findStructureFieldByKey(fields, "project")?.label ?? tableColumnType[TableTypeEnum.PROJECTS].name }}
        data={projects}
        deleteArrFunc={(queryArr) =>
          deleteArrFunc(queryArr, `${API_URL_PROJECT}/archive`, setIsDeleted)
        }
      />
      <DataTable
        table={{ ...tableColumnType[TableTypeEnum.COMPANY_EMPLOYEES], name: findStructureFieldByKey(fields, "companyContacts")?.label ?? tableColumnType[TableTypeEnum.COMPANY_EMPLOYEES].name }}
        data={employees}
      />
    </AppLayout>
  );
}

export const ButtonSpan = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  border-left: 2px solid ${COLORS.gray};
  padding-left: 16px;
`;
